module.exports = __webpack_public_path__ + "static/media/cat-10.fa600611.jpg";